import { authPlan } from './AuthStore';

export const updateAuthPlan = (value) => authPlan.update((oldValue) => value);
